import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  get(key: string): any {
    try {
      // Local storage
      const objectJson = localStorage.getItem(key);
      if (objectJson) {
        const object = JSON.parse(objectJson);
        return object;
      }
    } catch (error) {
      localStorage.removeItem(key);
    }

    return null;
  }

  set(key: string, value: any): void {
    // Local storage
    if (value === null) {
      this.remove(key);
      return;
    }
    const objectJson = JSON.stringify(value);
    localStorage.setItem(key, objectJson);
  }

  remove(key: string): void {
    // Local storage
    localStorage.removeItem(key);
  }

  clear(): void {
    // Local storage
    localStorage.clear();
  }
}
